enum RouteName {
    LOGIN = 'Login',
    HOME = 'Home',
    USER_OVERVIEW = 'UserOverview',
    GPP_USERS = 'GPPUsers',
    CREATE_GPP_USER = 'GPPUsersCreate',
    COPY_GPP_USER = 'GPPUsersCopy',
    VIEW_GPP_USER = 'GPPUsersView',
    EDIT_GPP_USER = 'GPPUsersEdit',
    SHIPIT_ADMINISTRATION = 'ShipITAdministration',
    CREATE_SHIPIT_FARM_USER = 'ShipITAdministrationCreateFarm',
    CREATE_SHIPIT_WEB_USER = 'ShipITAdministrationCreateWeb',
    EDIT_SHIPIT_FARM_USER = 'ShipITAdministrationEditFarm',
    EDIT_SHIPIT_WEB_USER = 'ShipITAdministrationEditWeb',
    CHANGE_SHIPPER_SETTINGS = 'ShipITAdministrationChangeShipperSettings',
    ACTION_LOG = 'ActionLog',
    TRACKING = 'Tracking',
    TRACKING_CREATE_USER = 'TrackingCreateUser',
    TRACKING_EDIT_USER = 'TrackingEditUser'
}

export { RouteName };
